import {IsDateString, IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Length, Min} from "class-validator";
import {Sim} from "../../sim";

export class UpdateSimDTO {


    @IsNotEmpty()
    @IsString()
    @Length(3, 30)
    identifier: string;

    @IsOptional()
    @IsDateString()
    expirationDate?: Date;

    @IsOptional()
    @IsInt()
    @Min(0)
    dataUsage?: number;

    @IsOptional()
    @IsInt()
    maxDataUsable?: number;

    @IsOptional()
    @IsString()
    @Length(1, 30)
    simOperator?: string

    @IsOptional()
    @IsNumber()
    monthlyFee?: number;


    constructor(sim : Sim) {
        this.identifier = sim.identifier!;

        if (sim.expirationDate) this.expirationDate = sim.expirationDate;
        if (sim.dataUsage) this.dataUsage = sim.dataUsage;
        if (sim.maxDataUsable) this.maxDataUsable = sim.maxDataUsable;
        if(sim.simOperator) this.simOperator = sim.simOperator;
        if (sim.monthlyFee) this.monthlyFee = sim.monthlyFee;

    }

}

